import { useQuery } from '@tanstack/react-query';
import { isListEnabled } from 'utils/queryHelpers';

import { statisticsService } from 'services';
import { QueryContextFromKeys, QueryParamModel } from 'models';

type CompletedAfterDeadLineContexts = QueryContextFromKeys<typeof completedAfterDeadlineKeys>;

export const completedAfterDeadlineKeys = {
  all: [{ scope: 'completedAfterDeadLine' }] as const,
  lists: () => [{ ...completedAfterDeadlineKeys.all[0], entity: 'list' }] as const,
  list: (params?: QueryParamModel | null) =>
    [{ ...completedAfterDeadlineKeys.lists()[0], params }] as const,
};

const fetchCompletedAfterDeadLineList = async ({
  queryKey: [{ params }],
}: CompletedAfterDeadLineContexts['list']) =>
  statisticsService.getCompletedAfterDeadLineList(params);

const exportCompletedAfterDeadLine = async ({
  queryKey: [{ params }],
}: CompletedAfterDeadLineContexts['list']) =>
  statisticsService.exportCompletedAfterDeadLineStatistics(params);

export const useCompletedAfterDeadLineList = (params?: QueryParamModel | null) =>
  useQuery({
    queryKey: completedAfterDeadlineKeys.list(params),
    queryFn: fetchCompletedAfterDeadLineList,
    enabled: isListEnabled(params),
  });

export const useExportCompletedAfterDeadLine = (params?: QueryParamModel | null) => {
  return useQuery({
    queryKey: completedAfterDeadlineKeys.list(params),
    queryFn: exportCompletedAfterDeadLine,
    enabled: false,
  });
};
